export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/ebbf9a4e0444b3d99cb5c3272e01c146/817588e876bd2f790f0ed4f621284189.jpeg" 
                alt="Cheers Wines & Spirits Logo" 
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Ghana's leading distributor of premium wines and spirits. We provide high-quality local and international brands with exceptional customer service and reliable delivery.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-yellow-400 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#home" className="text-gray-300 hover:text-yellow-400 transition-colors">Home</a></li>
              <li><a href="#products" className="text-gray-300 hover:text-yellow-400 transition-colors">Products</a></li>
              <li><a href="#services" className="text-gray-300 hover:text-yellow-400 transition-colors">Services</a></li>
              <li><a href="#about" className="text-gray-300 hover:text-yellow-400 transition-colors">About Us</a></li>
              <li><a href="#contact" className="text-gray-300 hover:text-yellow-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-yellow-400 mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-yellow-400"></i>
                <span className="text-gray-300 text-sm">Dome-Crossing, Ghana</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-yellow-400"></i>
                <span className="text-gray-300 text-sm">0546412997 / 0531506550</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-yellow-400"></i>
                <span className="text-gray-300 text-sm">cheerswinespirit@gmail.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-instagram-line text-yellow-400"></i>
                <span className="text-gray-300 text-sm">@cheerswinespirits</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Cheers Wines & Spirits. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-yellow-400 transition-colors text-sm mt-2 md:mt-0"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}